import { router, usePathname } from "expo-router";
import React, { useMemo } from "react";

import useTranslation from "$src/core/hooks/use-translation";
import ErrorPage from "$src/core/pages/ErrorPage/ErrorPage";

const NotFoundPage: React.FC = () => {
  const path = usePathname();
  const { t } = useTranslation();

  const error = useMemo(() => new Error(`Route not found: ${path}`), [path]);

  return (
    <ErrorPage
      title={t("ERROR/NOT_FOUND/TITLE")}
      subtitle={t("ERROR/NOT_FOUND/SUBTITLE")}
      ctaText={t("ERROR/NOT_FOUND/CTA")}
      ctaIcon="home"
      onPressCta={() => router.replace("/")}
      error={error}
    />
  );
};

export default NotFoundPage;
